export const EMAIL_REGEX = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/gi;
export const PHONE_REGEX = /[\d-()]{14}/;
export const ZIP_CODE_REGEX = /^\d{5}(?:[-\s](\d{5}|_{5}))$/;
